import BaseTable from 'components/Tables/BaseTable';
import { actions as flowsActions } from 'ducks/flows';
import { actions as stepRawMaterialsActions } from 'ducks/stepRawMaterials';
import { sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { filterStepRawMaterials, groupBy } from 'selectors/generic';
import theme from 'source/theme';
import arrayToObject from 'utils/arrayToObject';
import { F, F_ID, IS, IS_ID, LCS_LIST, M, M_ID } from 'utils/constants/lcsTypes';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/flowStepsRawMaterials';
import { currentUser } from 'selectors/currentUser';

// `step.substeps` is gone: the substeps of a step are the steps that name it as
// their master.
const substepsByMasterStep = groupBy('steps', 'master_step_id');

const Component = props => {
  let {
    flowId, flowSteps, rawMaterials, rawMaterialId, lcsByFLowIdScenarios,
    stepRawMaterials, stepsById, substepsByMasterStep, user
  } = props;
  const { create, fetchStepRawMaterials, fetchFlow, handleCloseDrawer, remove, update } = props;
  const tableRef = React.useRef(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    setSelectedIds(stepRawMaterials.map(rm => rm.step_id));
    setSteps(stepsWithLCSInfo());
  }, [stepRawMaterials, flowSteps]);

  console.log("stepRawMaterialsSpecial");
  console.log(stepRawMaterials);

  const stepsWithLCSInfo = () => {
    const stepRawMaterialsById = arrayToObject(stepRawMaterials, 'step_id');
    return flowSteps
      .filter(fs => fs.master_step_id ||
        (!fs.master_step_id && (substepsByMasterStep[fs.id] || []).length === 0))
      .map(s => {
        if (stepRawMaterialsById[s.id] && stepRawMaterialsById[s.id].descriptors) {
          return s.master_step_id ?
            {
              ...s,
              master_step_name: stepsById[s.master_step_id].name,
              master_step_description: stepsById[s.master_step_id].description,
              substep_name: s.name,
              substep_description: s.description,
              step_raw_material_id: stepRawMaterialsById[s.id].id,
              M: stepRawMaterialsById[s.id].descriptors.includes(M),
              F: stepRawMaterialsById[s.id].descriptors.includes(F),
              IS: stepRawMaterialsById[s.id].descriptors.includes(IS),
              M_error: !lcsByFLowIdScenarios[flowId].includes(M_ID),
              F_error: !lcsByFLowIdScenarios[flowId].includes(F_ID),
              IS_error: !lcsByFLowIdScenarios[flowId].includes(IS_ID)
            } :
            {
              ...s,
              master_step_name: s.name,
              master_step_description: s.description,
              substep_name: '',
              substep_description: '',
              step_raw_material_id: stepRawMaterialsById[s.id].id,
              M: stepRawMaterialsById[s.id].descriptors.includes(M),
              F: stepRawMaterialsById[s.id].descriptors.includes(F),
              IS: stepRawMaterialsById[s.id].descriptors.includes(IS),
              M_error: !lcsByFLowIdScenarios[flowId].includes(M_ID),
              F_error: !lcsByFLowIdScenarios[flowId].includes(F_ID),
              IS_error: !lcsByFLowIdScenarios[flowId].includes(IS_ID)
            };

        } else {
          return s.master_step_id ?
            {
              ...s,
              master_step_name: stepsById[s.master_step_id].name,
              master_step_description: stepsById[s.master_step_id].description,
              substep_name: s.name,
              substep_description: s.description,
              step_raw_material_id: '',
              M: false,
              F: false,
              IS: false
            } :
            {
              ...s,
              master_step_name: s.name,
              master_step_description: s.description,
              substep_name: '',
              substep_description: '',
              step_raw_material_id: '',
              M: false,
              F: false,
              IS: false
            };
        }
      });
  };

  const selectedSteps = steps.map(step =>
    selectedIds.includes(step.id) ?
      { ...step, tableData: { checked: true } } :
      { ...step, tableData: { checked: false } }
  );
  const orderedSteps = sortBy(selectedSteps, [row => !selectedIds.includes(row.id), 'id']);

  return (
    <BaseTable
      ref={tableRef}
      titleBack={true}
      titleAction={handleCloseDrawer}

      title={`${rawMaterials[rawMaterialId].code} - ${rawMaterials[rawMaterialId].name}`}
      icons={tableIcons}
      columns={columns(user)}
      data={orderedSteps}
      order={false}
      onRowClick={() => null}
      editable={{
        onRowUpdate: (newData, oldData) => {
          setLoading(true);
          const stepRawMaterialById_etapa = arrayToObject(stepRawMaterials, 'step_id');
          const descriptors = LCS_LIST.filter(lcs => newData[lcs] === true || newData[lcs] === 'true');
          if (oldData.tableData.checked) {
            return update(
              stepRawMaterialById_etapa[newData.id].id,
              {
                descriptors,
                flow_id: flowId,
                master_step_id: newData.id
              }
            )
              .then(() => setLoading(false))
              .catch(e => {
                setLoading(false);
                alert(e);
              });
          } else {
            return create({
              descriptors,
              step_id: newData.id,
              raw_material_id: rawMaterialId
            })
              .then(() => fetchFlow(flowId))
              .then(() => setLoading(false))
              .catch(e => {
                setLoading(false);
                alert(e);
              });
          }
        }
      }}
      options={{
        selection: true,
        showTextRowsSelected: false,
        showSelectAllCheckbox: false,
        rowStyle: rowData => ({
          backgroundColor: (selectedIds.includes(rowData.id) && !rowData.M && !rowData.F && !rowData.IS) ?
            theme.palette.rowErrorBackground.main : ''
        })
      }}
      isLoading={loading}
      onSelectionChange={(rows, difRow) => {
        setLoading(true);
        if (rows.length > selectedIds.length) {
          const descriptors = LCS_LIST.find(lcs => difRow[lcs] === true || difRow[lcs] === 'true');
          create({
            descriptors,
            step_id: difRow.id,
            raw_material_id: rawMaterialId
          })
            .then(() => fetchFlow(flowId))
            .then(() => setLoading(false))
            .catch(e => {
              setLoading(false);
              alert(e);
            });
        } else {
          const stepRawMaterialById_etapa = arrayToObject(stepRawMaterials, 'step_id');
          remove(stepRawMaterialById_etapa[difRow.id].id)
            .then(() => fetchFlow(flowId))
            .then(() => setLoading(false))
            .catch(e => {
              setLoading(false);
              alert(e);
            });
        }
      }}
    />
  );
};

const makeMapStateToProps = () => {
  const stepRawMaterials = filterStepRawMaterials();
  const mapStateToProps = (state, props) => ({
    stepRawMaterials: stepRawMaterials(state, props),
    rawMaterials: state.rawMaterials.models,
    stepsById: state.steps.models,
    substepsByMasterStep: substepsByMasterStep(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  fetchStepRawMaterials: () => dispatch(stepRawMaterialsActions.fetchAll()),
  fetchFlow: (id) => dispatch(flowsActions.fetchOne(id)),
  create: data => dispatch(stepRawMaterialsActions.createPromise(data)),
  remove: id => dispatch(stepRawMaterialsActions.removePromise(id)),
  update: (id, data) => dispatch(stepRawMaterialsActions.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
